import { RecentMatchesIds } from "components/Matches/RecentMatchesIds";
import { UpcomingMatchesIds } from "components/Matches/UpcomingMatchesIds";
import { Panel } from "components/Panel/Panel";
import { TabBar } from "components/TabBar/TabBar";
import { Filter } from "model/Filter/Filter";
import { Theme } from "model/Theme";
import { GrowColumn } from "pages/styles";
import { useState } from "react";

interface Props {
  matchIds: string[];
  theme: Theme | undefined;
}

export const MatchesTab = ({ matchIds, theme }: Props) => {
  const filterOptions = ["Recent", "Upcoming"];
  const [selectedTab, setSelectedTab] = useState(filterOptions[0]);
  const tabFilter: Filter<string> = {
    options: filterOptions,
    selectedValue: selectedTab,
    setSelectedValue: setSelectedTab,
  };

  return (
    <GrowColumn>
      <Panel>
        <TabBar
          filter={tabFilter}
          isSecondaryTabBar={true}
          primaryColor={theme?.primary}
          secondaryColor={theme?.secondary}
        />
      </Panel>
      {getTabContent(selectedTab, matchIds, theme?.secondary)}
    </GrowColumn>
  );
};

const getTabContent = (
  selectedTab: string,
  matchIds: string[],
  hoverColor: string | undefined
) => {
  switch (selectedTab) {
    case "Recent":
      return (
        <RecentMatchesIds
          matchIds={matchIds}
          showTrackScores={true}
          hoverColor={hoverColor}
        />
      );
    case "Upcoming":
      return (
        <UpcomingMatchesIds
          matchIds={matchIds}
          showTrackScores={true}
          hoverColor={hoverColor}
        />
      );
    default:
      return <></>;
  }
};
